var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _ellipse2, _path8, _path9, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _polygon, _polygon2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlaggedQuestions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "330px",
    height: "358px",
    viewBox: "0 0 330 358",
    style: {
      enableBackground: "new 0 0 330 358"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st3{opacity:0.949;fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st5{opacity:0.949;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#000000;stroke-width:9;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st8{stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st9{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st10{fill:none;stroke:#000000;stroke-width:19;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st11{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st12{clip-path:url(#SVGID_2_);}\r\n\t.st13{clip-path:url(#SVGID_4_);}\r\n\t.st14{clip-path:url(#SVGID_6_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st15{clip-path:url(#SVGID_8_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st16{clip-path:url(#SVGID_10_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st17{clip-path:url(#SVGID_12_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st18{opacity:0.9686;clip-path:url(#SVGID_14_);enable-background:new    ;}\r\n\t.st19{clip-path:url(#SVGID_16_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st20{opacity:0.9686;clip-path:url(#SVGID_18_);enable-background:new    ;}\r\n\t.st21{clip-path:url(#SVGID_20_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st22{clip-path:url(#SVGID_22_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st23{clip-path:url(#SVGID_24_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st24{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st25{clip-path:url(#SVGID_26_);}\r\n\t.st26{clip-path:url(#SVGID_28_);}\r\n\t.st27{clip-path:url(#SVGID_30_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st28{clip-path:url(#SVGID_32_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st29{clip-path:url(#SVGID_34_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st30{clip-path:url(#SVGID_36_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st31{opacity:0.9686;clip-path:url(#SVGID_38_);enable-background:new    ;}\r\n\t.st32{clip-path:url(#SVGID_40_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st33{opacity:0.9686;clip-path:url(#SVGID_42_);enable-background:new    ;}\r\n\t.st34{clip-path:url(#SVGID_44_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st35{clip-path:url(#SVGID_46_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st36{clip-path:url(#SVGID_48_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st37{clip-path:url(#SVGID_50_);}\r\n\t.st38{clip-path:url(#SVGID_52_);}\r\n\t.st39{clip-path:url(#SVGID_54_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st40{clip-path:url(#SVGID_56_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st41{clip-path:url(#SVGID_58_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st42{clip-path:url(#SVGID_60_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st43{opacity:0.9686;clip-path:url(#SVGID_62_);enable-background:new    ;}\r\n\t.st44{clip-path:url(#SVGID_64_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st45{opacity:0.9686;clip-path:url(#SVGID_66_);enable-background:new    ;}\r\n\t.st46{clip-path:url(#SVGID_68_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st47{clip-path:url(#SVGID_70_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st48{clip-path:url(#SVGID_72_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st49{clip-path:url(#SVGID_74_);}\r\n\t.st50{clip-path:url(#SVGID_76_);}\r\n\t.st51{clip-path:url(#SVGID_78_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st52{clip-path:url(#SVGID_80_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st53{clip-path:url(#SVGID_82_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st54{clip-path:url(#SVGID_84_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st55{opacity:0.9686;clip-path:url(#SVGID_86_);enable-background:new    ;}\r\n\t.st56{clip-path:url(#SVGID_88_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st57{opacity:0.9686;clip-path:url(#SVGID_90_);enable-background:new    ;}\r\n\t.st58{clip-path:url(#SVGID_92_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st59{clip-path:url(#SVGID_94_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st60{clip-path:url(#SVGID_96_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st61{stroke:#000000;stroke-miterlimit:10;}\r\n\t.st62{fill:none;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M140.41,311.08l-0.57,7.59l-7,2.74c0,0,8.01-4.78,14.72-2.15c4.93,1.93,9.07,10.84,9.23,13.76 c0.09,2.01-5.88,5.89-7.22,4.59c-1.59-1.51-1-5.88-0.78-9.13c0.35-5.19-5.94-6.23-5.94-6.23s4.53,1.61,4.96,2.91 c0.48,1.54,1.02,5.09,0.52,8.11c-0.22,1.39-0.19,3.28-0.78,4.29c-0.66,1.19-2.01,1.39-2.86,1.58c-1.12,0.24-5.31,0.73-6.67-0.65 c-1.18-1.23-0.63-3.22-1.06-5.06c-0.73-3.07-1.94-5.94-1.94-5.94l1.51,6.02c0,0,0.45,3.94-0.36,4.83c-1.51,1.71-6.6,2.06-8.7,1.44 c-2.96-0.89-8.93-3.83-10.56-6.54c-1.2-1.99-2.63-7.15-1.58-9.3c0.79-1.56,5.68-3.82,5.68-3.82l0.02-3.89 c0,0.31,0.89,0.03,1.09,0.15c0.58,0.37,2.86,0.17,2.86,0.17s2.26-0.04,3.52-0.15c1.26-0.11,2.98-0.61,4.32-1.09 C137.24,313.7,140.41,311.08,140.41,311.08z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M76.08,318.35l3.03,6.96l7.5,0.21c0,0-9.12-1.78-14.58,2.98c-4.02,3.5-5,13.3-4.2,16.11 c0.57,1.93,7.47,3.55,8.31,1.88c1-1.97-0.98-5.88-2.25-8.87c-2.03-4.78,3.56-7.89,3.56-7.89s-3.74,3.06-3.73,4.43 c0.05,1.61,0.7,5.14,2.16,7.83c0.67,1.24,1.25,3.03,2.14,3.79c1.02,0.9,2.35,0.63,3.22,0.51c1.13-0.16,5.24-1.11,6.08-2.88 c0.71-1.56-0.46-3.25-0.66-5.13c-0.31-3.14-0.12-6.26-0.12-6.26l0.55,6.18c0,0,0.87,3.87,1.92,4.43c1.99,1.1,6.89-0.3,8.67-1.6 c2.5-1.85,7.16-6.65,7.82-9.75c0.48-2.28,0.14-7.64-1.56-9.31c-1.25-1.2-6.6-1.68-6.6-1.68l-1.58-4.26c0.1,0.3-0.68,0.56-0.83,0.75 c-0.43,0.55-1.27,0.45-2.5,1.49c-0.83,0.7-2.14,0.73-3.36,1.05c-1.22,0.33-2.35,0.94-3.77,0.94 C80.58,320.26,76.08,318.35,76.08,318.35z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M124.79,148.9c34.83-6.23,37.97-2.25,64.16-22.05c5.49-4.15,17.64-7.64,22.56-3.63 c4.93,4-0.95,14.36-6.57,18.41c-27.53,19.8-28.51,16.6-64.21,23.89c1.16,14.68,3.36,30.26,5.56,45.84c0.3,2.16-1.94,4.48-4.76,4.93 c-17.55,2.77-35.11,5.54-52.66,8.31c-6.18,0.98-12.09-3.81-10.54-8.54c4.33-13.3,5.44-27.05,3.23-40.29 c-22.62,13.02-33.46,21.02-30.13,41.51c0.77,4.71-6.31,11.73-12.53,12.33s-11.16-4.56-11.05-9.36c0.38-17.19,2.63-21.41,12.58-37.34 s29.83-29.69,52.15-30.79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M108.17,156.57c3.11-1.15,6.94,1.14,7.55,4.4c0.61,3.26-1.97,6.71-5.25,7.2c-3.28,0.49-6.68-1.91-7.48-5.12 c-0.8-3.22,2.42-5.05,5.37-6.55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M114.33,166.48c2.35,6.91,3.25,14.31,2.85,21.64c-1.61,1.87-3.23,3.74-4.84,5.61 c-1.67-1.88-3.34-3.76-5.31-5.53c0.23-6.52,0.45-13.05,0.68-19.57"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M78.6,222.28c-3.13,29.71-7.94,56.03-11.06,85.74c-0.63,5.99,8.21,12.6,17.88,11.85 c9.67-0.76,17.32-8.1,16.63-13.99c-3.08-26.11,1-48.26,10.29-74.76c-0.98,25.22-1.96,50.44-2.94,75.66 c-0.22,5.69,8.02,10.34,17.23,9.71c9.21-0.62,17.7-6.39,17.75-12.07c0.26-29.58,0.51-59.15,0.77-88.73"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M29.49,226.38c-3.29,5.13-5.72,10.69-7.19,16.46c-0.22,0.87,0.41,1.86,1.39,2.16c0.98,0.3,2.15-0.14,2.57-0.95 c1.94-3.78,3.88-7.56,5.81-11.34c-1.73,3.7-3.47,7.41-5.2,11.11c-0.43,0.92,0.42,2.05,1.53,2.3c1.11,0.26,2.29-0.2,3.07-0.92 s1.21-1.67,1.58-2.6c1.34-3.4,2.68-6.79,4.02-10.19c-1.53,3.77-3.06,7.55-4.59,11.32c-0.33,0.82,0.22,1.85,1.16,2.16 s2.11-0.15,2.46-0.96c1.74-4.12,3.49-8.24,5.23-12.36c1.42,0.86,2.88,1.73,4.56,2.06c1.67,0.32,3.63-0.04,4.58-1.26 c0.95-1.22,0.31-3.3-1.36-3.62c-2.17-0.42-4.35-0.84-6.52-1.26"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6825 -0.7309 0.7309 0.6825 -52.6191 95.3016)",
    className: "st24",
    cx: 83.39,
    cy: 108.22,
    rx: 17.8,
    ry: 18.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6825 -0.7308 0.7308 0.6825 -40.4154 128.261)",
    className: "st24",
    cx: 127.43,
    cy: 110.65,
    rx: 17.8,
    ry: 18.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M101.37,109.98c0.2-1.58,2.07-2.84,4.07-2.75c2,0.1,3.82,1.53,3.95,3.12"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M119.08,130.29c-8.53-3.13-18.93-3.73-28.63-2c1.78,6.57,7.59,11.6,13.76,11.94 c6.18,0.34,12.29-4.02,14.5-10.38"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_49_",
    points: "63.56,62.73 152,67.62 149.1,155.44 60.65,150.56  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_51_",
    points: "63.56,62.73 152,67.62 149.1,155.44 60.65,150.56  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_51_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_53_",
    points: "63.56,62.73 152,67.62 149.1,155.44 60.65,150.56  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_53_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M126.6,141.9 c-5.16,2.76-14.81,4.61-23.39,4.13"
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_55_",
    points: "63.56,62.73 152,67.62 149.1,155.44 60.65,150.56  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_55_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_8_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M128.68,140.65 c-0.45,0.34-2.11,1.27-2.11,1.27L128.68,140.65z"
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_57_",
    points: "63.56,62.73 152,67.62 149.1,155.44 60.65,150.56  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_57_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_10_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M136.06,95.29 c9.79,6.27,9.21,13.75,9.05,18.58c-0.4,12.16-10.09,21.99-16.46,26.79"
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_59_",
    points: "63.56,62.73 152,67.62 149.1,155.44 60.65,150.56  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_59_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_12_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M103.31,146.05 c-22.12-1.22-41.21-17.83-38.89-36.58c0.65-5.26,0.7-12.61,11.22-17.91"
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_61_",
    points: "63.56,62.73 152,67.62 149.1,155.44 60.65,150.56  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_61_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_63_",
    points: "70.22,69.8 89.03,70.84 88.31,92.63 69.5,91.59  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_63_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_16_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M88.4,79.46 c-3.45-3.38-7.18-6.18-11.62-8.17c-1.55-0.74-3.34-1.27-4.73-0.26c-0.69,0.62-1.4,1.44-1.43,2.3 c-0.4,5.18,0.08,9.34,2.17,14.01c0.85,1.56,1.89,4.07,3.09,4.14"
  }))))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_65_",
    points: "63.56,62.73 152,67.62 149.1,155.44 60.65,150.56  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_65_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_67_",
    points: "123.2,71.55 147.44,72.89 146.66,96.29 122.43,94.95  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_67_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_20_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M135.58,95.27 c3.01-1.34,7.11-2.84,7.91-6.17c-1.93,0.34-3.22,0.3-5.16,0.57c3.24-1.76,6.09-4.27,7.83-7.47 c-1.57,0.5-3.07,1.16-4.63,1.67c1.41-3.14,2.44-6.98,0.29-10.14c-1.09-1.15-2.68-0.8-4.04-0.44 c-5.48,2.3-10.11,5.94-14.61,9.59"
  }))))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_69_",
    points: "63.56,62.73 152,67.62 149.1,155.44 60.65,150.56  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_69_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_22_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M125.09,81.31 c-0.67,0.39-0.97,1.3-1.72,1.54c-0.32,0.1-0.67,0.06-1-0.01c-3.09-0.57-5.77-2.44-8.43-4.09c-2.67-1.65-5.68-3.18-8.62-2.62 c3.63,0.91,6.85,3.33,8.44,6.59c-3.36-2.34-7.45-3.61-11.54-4.02c-4.09-0.41-7.5,0.24-11.51,1.03 c-0.87,0.17-1.96,0.29-2.49-0.42"
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_71_",
    points: "63.56,62.73 152,67.62 149.1,155.44 60.65,150.56  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_71_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_24_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M138.95,78.19 c2.71-0.97-1.71,0.45-2.73,1.72c-1.2,1.47-5.38,5.57-5.77,7.43c-0.11,0.52-0.21,1.06-0.51,1.51 c-0.65,0.96-2.03,1.11-3.22,1.11c-4.36-0.04-8.66-1.17-13.03-1.36c-0.91-0.04-1.88-0.03-2.65,0.41 c-1.27,0.72-1.81,2.46-3.26,2.77c-1.59,0.34-2.88-1.21-4.04-2.34c-1.83-1.78-4.31-2.86-6.85-3.31 c-2.54-0.46-5.14-0.31-7.68,0.07c-1.42,0.21-2.86,0.51-4.31,0.32c-0.33-0.04-0.68-0.12-0.93-0.33 c-0.29-0.24-0.4-0.59-0.51-0.94c-0.94-2.91-2.35-5.68-4.17-8.19c-0.46-0.62-2.34-2.09-3.08-2.33 c-2.3-0.71,2.72,0.92,3.02,2.33"
  })))))))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "92.59,152.33 106.6,153.06 95.91,165.95 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "124.05,149.26 110.49,152.84 123.6,163.28 "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M274.72,40.07c-3.67,6.93-3.44,14.48-3.4,21.99c0.01,1.61,0.14,3.22,0.13,4.83c-0.01,2.79-1.58,4.77-4.22,5.35 c-7.78,1.71-15.41,0.84-23.02-1.18c-3.66-0.97-6.75-3.16-10.28-4.36"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M267.72,31.14c-0.25-0.56-0.41-1.18-0.77-1.67c-4.19-5.78-1.73-10.91,4.25-13.71c4.05-1.9,8.43-2.16,12.8-2.27 c10.82-0.28,21.09,2.19,31.03,6.27c0.35,0.14,0.61,0.48,0.92,0.73"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M271.66,45.13c3.01,3.82,7.31,3.92,11.6,4.02c7.17,0.18,14.36-0.58,21.52,0.93c2.28,0.48,4.34,1.77,6.91,1.54 c0.56-2.24-0.36-4.56-0.49-6.92c-0.35-6.3-0.67-12.59,2.13-18.5c0.73-1.53,1.75-2.92,2.63-4.37"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M236.31,31.21c7.9,5.57,16.99,6.41,26.21,6.31c2.2-0.02,3.23-2.68,4.65-4.29c0.51-0.57,0.39-1.71,1.55-1.69"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M236.73,31.14c-0.68,5.34-1.48,10.65-1.9,16.04c-0.46,5.92-0.28,11.9-1,17.72 c-1.34,10.82-1.21,21.71-2.27,32.52c-0.07,0.73,0.04,1.4-0.87,1.9c-0.93,0.51-0.51,1.49-0.13,2.3c0.48,1.03,0.97,2.07,1.39,3.12 c0.64,1.58,0.77,3.06-1.14,4.03c-1.56-1.05-2.99-2.17-4.18-3.66c-2.56-3.19-2.26-4.16,1.77-5.12"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M226.23,101.74c-6.24,1.54-8.33,6.26-9.41,11.93c-0.73,3.85-2.68,6.84-6.26,6.99"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M235.44,47.57c1.32,0.24,1.76,1.55,2.72,2.25c6.98,5.06,14.7,6.91,23.2,5.46"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M289.03,32.79c8.15-1.02,15.4,1.29,21.99,6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M230.85,109.25c-1.27,1.07-1.93,2.59-2.89,3.89"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M213.98,128.9c6.64,1.11,13.79-1.66,17.95-6.95c1.61-2.05,2.81-4.5,3-7.1c0.19-2.51-0.6-5.07-2.15-7.05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlaggedQuestions);
export default __webpack_public_path__ + "static/media/flaggedQuestions.a247c4940ed489073b4929cb58e61aba.svg";
export { ForwardRef as ReactComponent };